const buildTypeOptions = {
    PROMPT: 'prompt',
    BRIEF_FILE: 'brief_file',
};

export default buildTypeOptions;
